import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { Market } from '@ionic-native/market/ngx';
import { environment } from '../../../../environments/environment';
import { Plugins } from '@capacitor/core';

const { Device } = Plugins;

@Component({
  selector: 'app-modal-atualizacao-app',
  templateUrl: './modal-atualizacao-app.page.html',
  styleUrls: [ './modal-atualizacao-app.page.scss' ],
})
export class ModalAtualizacaoAppPage implements OnInit {

  BUNDLE_APP = environment.bundleId;
  URL_ATUALIZACAO_APP = environment.urlAtualizacao;

  isHybrid;

  constructor(private modalController: ModalController,
              private router: Router,
              private market: Market,
              private platform: Platform
  ) {
  }

  ngOnInit() {
    this.isHybrid = this.platform.is('hybrid');
  }

  async fechar() {
    await this.modalController.dismiss();
  }

  async abrirLoja() {
    if (this.isHybrid) {
      const deviceInfo = await Device.getInfo();
      if (deviceInfo.appBuild !== this.BUNDLE_APP) {
        await this.market.open(deviceInfo.appBuild);
      } else {
        open(this.URL_ATUALIZACAO_APP);
      }
    } else {
      window.location.reload();
    }
  }
}
